import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { CfrGroup } from 'interfaces/api/cfrGroups.interfaces'
import { CreateCfrGroupParams, RemoveCfrGroupParams, UpdateCfrGroupParams } from 'interfaces/store/cfrGroups.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllCfrGroups = createAsyncThunk('cfrGroups/getAllCfrGroups', async (_, { rejectWithValue }) =>
  api.cfrGroups.getAll().catch((error) => rejectWithValue(error.message)),
)

export const setCfrGroupValidationErrors = createAction<ValidationErrorsApi | null>(
  'cfrGroups/setCfrGroupValidationErrors',
)

export const createCfrGroup = createAsyncThunk(
  'cfrGroups/createCfrGroup',
  async (params: CreateCfrGroupParams, { rejectWithValue, dispatch }) =>
    api.cfrGroups
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setCfrGroupValidationErrors(null))
        toast.success(Success.CfrGroupCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setCfrGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateCfrGroup = createAsyncThunk(
  'cfrGroups/updateCfrGroup',
  async (params: UpdateCfrGroupParams, { rejectWithValue, dispatch }) =>
    api.cfrGroups
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setCfrGroupValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setCfrGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeCfrGroup = createAsyncThunk(
  'cfrSettings/removeCfrGroup',
  async (params: RemoveCfrGroupParams, { rejectWithValue }) =>
    api.cfrGroups
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.CfrGroupRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const setSingleCfrGroup = createAction<CfrGroup | null>('cfrGroups/setSingleCfrGroup')
